import { PayloadAction } from "@reduxjs/toolkit";
import { CustomerState } from "../customer.slice.ts";
import { SessionInfoResponse } from "../../../../orchestrator-api-client";

export default function initStoreReducer(
  state: CustomerState,
  action: PayloadAction<SessionInfoResponse | undefined>,
) {
  if (action.payload) {
    if (action.payload.customer?.personalInfo) {
      state.personalInfo.firstName =
        action.payload?.customer?.personalInfo?.firstName ?? "";
      state.personalInfo.lastName =
        action.payload?.customer?.personalInfo?.lastName ?? "";
      state.personalInfo.fiscalCode =
        action.payload?.customer?.personalInfo?.fiscalCode ?? "";
      state.personalInfo.gender =
        action.payload?.customer?.personalInfo?.gender ?? "";
      state.personalInfo.nationality =
        action.payload?.customer?.personalInfo?.nationality ?? "";
    }
    if (action.payload.customer?.contacts) {
      state.contacts = {
        email: action.payload.customer?.contacts?.email ?? "",
        phonePrefix: "",
        phone: "",
      };
    }
    if (action.payload.customer?.birth) {
      state.birth.birthCity = action.payload.customer?.birth?.birthCity ?? "";
      state.birth.birthCountry =
        action.payload.customer?.birth?.birthCountry ?? "";
      state.birth.birthDate = {
        birthDay:
          action.payload.customer?.birth?.birthDate?.birthDay ?? undefined,
        birthMonth:
          action.payload.customer?.birth?.birthDate?.birthMonth ?? undefined,
        birthYear:
          action.payload.customer?.birth?.birthDate?.birthYear ?? undefined,
      };
      state.birth.birthProvince =
        action.payload.customer?.birth?.birthProvince ?? "";
    }
    if (action.payload.customer?.job) {
      state.job = {
        educationLevel: action.payload.customer?.job?.educationLevel ?? "",
        companySize: action.payload.customer?.job?.companySize ?? "",
        companyIndustry: action.payload.customer?.job?.companyIndustry ?? "",
        employerName: action.payload.customer?.job?.employerName ?? "",
        hireMonth: action.payload.customer?.job?.hireMonth ?? undefined,
        hireYear: action.payload.customer?.job?.hireYear ?? undefined,
        vatNumber: action.payload.customer?.job?.vatNumber ?? "",
        employmentStatus: action.payload.customer?.job?.employmentStatus ?? "",
        jobRole: action.payload.customer?.job?.jobRole ?? "",
        income: {
          grossAnnualSalary:
            action.payload.customer?.job?.income?.grossAnnualSalary ??
            undefined,
          hasOtherIncome:
            action.payload.customer?.job?.income?.hasOtherIncome ?? undefined,
          monthsSalary: action.payload.customer?.job?.income?.monthlySalary,
          netMonthlySalary:
            action.payload.customer?.job?.income?.netMonthlySalary,
          otherIncomeDescription:
            action.payload.customer?.job?.income?.otherIncomeDescription ??
            undefined,
          otherIncomeNetMonthlySalary:
            action.payload.customer?.job?.income?.otherIncomeNetMonthlySalary ??
            undefined,
        },
      };
    }
    if (action.payload.customer?.addressInfo) {
      state.addressInfo = {
        residence: {
          zipCode: action.payload.customer?.addressInfo?.residence?.zipCode,
          city: action.payload.customer?.addressInfo?.residence?.city,
          country: action.payload.customer?.addressInfo?.residence?.country,
          province: action.payload.customer?.addressInfo?.residence?.province,
          streetName:
            action.payload.customer?.addressInfo?.residence?.streetName,
          streetNumber:
            action.payload.customer?.addressInfo?.residence?.streetNumber,
        },
      };
      if (action.payload.customer?.addressInfo?.domicile) {
        state.addressInfo.domicile = {
          zipCode: action.payload.customer?.addressInfo?.domicile?.zipCode,
          city: action.payload.customer?.addressInfo?.domicile?.city,
          country: action.payload.customer?.addressInfo?.domicile?.country,
          province: action.payload.customer?.addressInfo?.domicile?.province,
          streetName:
            action.payload.customer?.addressInfo?.domicile?.streetName,
          streetNumber:
            action.payload.customer?.addressInfo?.domicile?.streetNumber,
        };
      }
    }
    if (action.payload.customer?.family) {
      state.family = {
        // maritalStatus: action.payload.customer?.family?.maritalStatus ?? "",
        maritalStatus: "",
        // householdMembers: action.payload.customer?.family?.householdMembers ?? '',
        householdMembers: undefined,
        // peopleWithIncome: action.payload.customer?.family?.peopleWithIncome ?? '',
        peopleWithIncome: "",
      };
    }
    if (action.payload.customer?.living) {
      state.living = {
        // homeStatus: action.payload.customer?.living?.homeStatus ?? '',
        homeStatus: "",
        // mortgageInstallmentAmount: action.payload.customer?.living?.mortgageInstallmentAmount,
        // rentInstallmentAmount: action.payload.customer?.living?.rentInstallmentAmount,
      };
    }
    if (action.payload.customer?.kycTentative) {
      state.kycTentative = action.payload.customer.kycTentative;
    }
  }
}
